var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConversationIconStatusSent(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.46662 12.4354L0.930786 8.89955L1.64362 8.19705L4.47695 11.0304L4.70762 10.7996L5.41029 11.5021L4.46662 12.4354ZM8.23329 12.4354L4.69745 8.89955L5.39995 8.18672L8.23329 11.0201L14.3666 4.88672L15.0691 5.59955L8.23329 12.4354ZM8.00245 8.89955L7.28962 8.19705L10.5896 4.89705L11.3025 5.59955L8.00245 8.89955Z",
    fill: "#AAB2A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversationIconStatusSent);
export default __webpack_public_path__ + "static/media/conversation_icon_status_sent.0750057d92d485e0ff370ead6a8dc014.svg";
export { ForwardRef as ReactComponent };